
<div class="eye-view-consignee mb-4">
  <div class="row eye-view-consignee-row ">
    <div class="col-4 mogo-bold text-end eye-view-consignee-header">
      Consignee
    </div>
    <div class="col-8 eye-view-consignee-content">
       {{ consigneeDetails.consigneeName}}
    </div>
  </div>
  <div class="row eye-view-consignee-row ">
    <div class="col-4 mogo-bold text-end eye-view-consignee-header">
      Address
    </div>
    <div class="col-8 eye-view-consignee-content">
       {{ consigneeDetails.consigneeAddress}}
    </div>
  </div>
  <div class="row">
    <div class="col-4 mogo-bold text-end eye-view-consignee-header">
      Customer Reference
    </div>
    <div class="col-8 eye-view-consignee-content">
      {{ consigneeDetails.customerReference}}
    </div>
  </div>
</div>
